import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
import VisitorDocumentsRemoveVisitorDocumentConfirmation from 'garaje/components/visitor-documents/remove-visitor-document-confirmation';
import type Invite from 'garaje/models/invite';
import type VisitorDocument from 'garaje/models/visitor-document';

interface RemoveVisitorDocumentConfirmationSignature {
  Args: {
    /**
     * action to close the modal
     */
    close: () => void;
    /**
     * task performed when confirming
     */
    onSubmit: (visitorDocument: VisitorDocument, invite?: Invite) => Promise<void>;
    visitorDocument: VisitorDocument;
    invite?: Invite;
  };
}

export default class RemoveVisitorDocumentConfirmation extends Component<RemoveVisitorDocumentConfirmationSignature> {
  onSubmitTask = dropTask(async (e: SubmitEvent) => {
    const { visitorDocument, invite } = this.args;

    e.preventDefault();

    await this.args.onSubmit(visitorDocument, invite);

    this.args.close();
  });

  <template>
    <VisitorDocumentsRemoveVisitorDocumentConfirmation
      @close={{@close}}
      @onSubmitTask={{this.onSubmitTask}}
      @visitorDocument={{@visitorDocument}}
    />
  </template>
}
